import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import { Contract } from '../../types/ContractType';
import { ContractPage } from '.';
import { LoadingContext } from '../../providers/loading';
import { UserDataContext } from '../../providers/userData';

export function ContractPageContainer() {
  const navigate = useNavigate();
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { userData } = useContext(UserDataContext);

  async function onSave({ number, owner_id }: Contract) {
    setIsLoading({ value: true });
    await api.post('/contracts', {
      number,
      owner_id
    },
    {
      headers: {
        'Authorization': `Bearer ${userData.token}`
      }
    })
      .then(() => {
        navigate('/contracts');
        setIsLoading({ value: false });
      })
      .catch(error => console.log(error));
  }

  return (
    <ContractPage
      isLoading={isLoading.value}
      onSave={onSave}
    />
  );
}
